// extracted by mini-css-extract-plugin
module.exports = {"LiveStreamContent":"ReaderActivity_LiveStreamContent__3Jvnu","studentMode":"ReaderActivity_studentMode__1JXBN","otherMode":"ReaderActivity_otherMode__1rJGd"};